import React from "react";
import { TabNavigationProps } from "./DataSharingTypes";

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  followersCount,
  followingCount,
}) => (
  <div className="flex w-full border-b mb-2 sm:w-4/5 md:w-3/4 lg:w-2/3 mx-auto">
    {[
      { key: "followers", label: "Followers", count: followersCount },
      { key: "following", label: "Following", count: followingCount },
    ].map((tab) => (
      <div
        key={tab.key}
        className={`w-1/2 py-2 text-center font-medium cursor-pointer transition-colors ${
          activeTab === tab.key
            ? "border-b-2 border-[#007C9E] text-gray-600"
            : "text-[#007C9E]"
        }`}
        onClick={() => onTabChange(tab.key as "followers" | "following")}
        style={{
          fontFamily: "'Figtree', sans-serif",
          fontStyle: "normal",
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "20px",
          letterSpacing: "0.374px",
          flex: "none",
          order: 0,
          flexGrow: 0,
        }}
      >
        <span className="mr-2">{tab.count > 0 ? tab.count : ""}</span>
        {tab.label}
      </div>
    ))}
  </div>
);

export default TabNavigation;
